import {
    type FinishPSLSFetchType,
    type StartPSLSFetchType,
    FINISH_PSLS_FETCH,
    START_PSLS_FETCH,
} from "../actions/FinanceInsuranceActions";
import type { PSLSDataType } from "../../../../shared-logic/types/PSLSDataType";

export type PSLSStateType = {
    data: PSLSDataType | null;
    fetching: boolean;
    error: boolean;
};

export const initialState: PSLSStateType = {
    data: null,
    fetching: false,
    error: false,
};

const pslsReducer = (
    state: PSLSStateType = initialState,
    action: StartPSLSFetchType | FinishPSLSFetchType,
): PSLSStateType => {
    switch (action.type) {
        case START_PSLS_FETCH:
            return { ...initialState, fetching: true, error: false };

        case FINISH_PSLS_FETCH: {
            return { data: action.data, fetching: false, error: action.error || false };
        }

        default:
            return state;
    }
};

export default pslsReducer;
